import React from 'react';
import { useAuth } from './../contextos/AuthContext';
import { Navigate } from 'react-router-dom';

const RutaProtegida = ({ children }) => {
	const { usuario, cargando } = useAuth();

	if (cargando) return null; // o un loader

	if (usuario) {
		return children;
	} else {
		return <Navigate to="/iniciar-sesion" replace />;
	}
}

export default RutaProtegida;